'use client';

import { useTranslations } from 'next-intl';

function NoWinnerIcon({ className }: { className?: string }) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25.9997 47.6666C37.9163 47.6666 47.6663 37.9166 47.6663 26C47.6663 14.0833 37.9163 4.33331 25.9997 4.33331C14.083 4.33331 4.33301 14.0833 4.33301 26C4.33301 37.9166 14.083 47.6666 25.9997 47.6666Z"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8682 32.1316L32.1315 19.8683"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1315 32.1316L19.8682 19.8683"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EventNoWinnerCard() {
  const t = useTranslations('event.noWinner');

  return (
    <div className="flex flex-col items-center gap-4 rounded-[16px] bg-v2-surface-secondary p-6 shadow-v2-card">
      <NoWinnerIcon className="text-v2-text-secondary" />
      <span className="text-center text-[24px] font-medium leading-8 text-v2-text-primary">
        {t('title')}
      </span>
    </div>
  );
}
